import { render, staticRenderFns } from "./exitChannel.vue?vue&type=template&id=34186aa0&scoped=true&"
import script from "./exitChannel.vue?vue&type=script&lang=js&"
export * from "./exitChannel.vue?vue&type=script&lang=js&"
import style0 from "./exitChannel.vue?vue&type=style&index=0&id=34186aa0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34186aa0",
  null
  
)

export default component.exports